<div
  class="app-form-group"
  [class.app-form-group--vertical]="orientation === appForm.formItemOrientation.VERTICAL"
  [class.qima-mb-l]="hasDistance"
  [class.app-form-group--invalid]="control?.invalid && control?.touched"
>
  <div
    class="app-form-group__label"
    [style.width.px]="labelWidth"
  >
    <ng-content select=".form-group-label"></ng-content>
  </div>
  <div
    class="app-form-group__input"
    [style.width.px]="inputWidth"
    [ngClass]="['app-form-group__input--size-' + size]"
  >
    <div class="app-form-group__input__content">
      <ng-content select=".form-group-input"></ng-content>
      <app-form-validation-message
        [formValidationMessageControl]="control"
        [formValidationFormGroup]="formGroup"
        [formValidationMessages]="validationMessages"
      ></app-form-validation-message>
      @if (shouldShowHint && hintMessage) {
        <span
          class="app-form-group__hint"
          data-cy="app-form-group-hint"
        >
          {{ hintMessage | translate }}
        </span>
      }
    </div>
  </div>
</div>
